(function () {
    'use strict';

    angular
        .module('directives.boxFormDirty', [])
        .directive('boxFormDirty', directive);

    directive.$inject = ['$rootScope'];

    function directive($rootScope) {
        return {
            require: ['form'],
            compile: function() {
                return {
                    pre: function ngModelPreLink(scope, element, attrs, ctrls) {
                        var formCtrl = ctrls[0];
                        var $setDirty = formCtrl.$setDirty;
                        var $setPristine = formCtrl.$setPristine;

                        formCtrl.$setDirty = function() {
                            $setDirty.call(this);

                            $rootScope.$broadcast('page-is-dirty');
                        };

                        formCtrl.$setPristine = function() {
                            $setPristine.call(this);

                            $rootScope.$broadcast('page-is-not-dirty');
                        };
                    }
                }
            }
        };
    }
})();